<span class="app-tags" title="{{tagNames[tag]}}" [class.tags-pill]="pill" [ngStyle]="getStyle()">
  {{tag}}
</span>
